// import { restRequest } from "vrcore-dashboard/dist/utilities";

export const SET_FROM_DATE =
    "VRCORE_DASHBOARD_V2.DATEPICKER_WIDGET.SET_FROM_DATE";
export const SET_TO_DATE = "VRCORE_DASHBOARD_V2.DATEPICKER_WIDGET.SET_TO_DATE";
